import React from 'react';
import { Grid, Divider } from 'semantic-ui-react';

import UserBadge from './UserBadge';
import TeamLocation from '../utils/TeamLocation';

import '../styles/TeamUsersGrid.css';

const STATUS_VIEW_MODE = 'status';
const LOCATION_VIEW_MODE = 'location';
const TIMEZONE_VIEW_MODE = 'timeZone';

const WFH_LOCATION = 'WFH';
const NOT_REVEALED_LOCATION = 'N/A';

const UNKNOWN_STATUS = 'unknown';
const JOIN_STATUS = 'join';
const AFK_STATUS = 'afk';
const LEAVE_STATUS = 'leave';

const BADGE_COLUMN_WIDTHS = {
  mobile: 12,
  tablet: 4,
  computer: 3,
  largeScreen: 2,
  widescreen: 2
};

const UserBadgeGrid = props => (
  <Grid padded className="TeamUsersGrid">
    {props.children}
  </Grid>
);

class TeamUsersGrid extends React.Component {
  get groupedUsersByStatus() {
    return this.props.users.reduce(
      (UsersByStatus, user) => {
        if (user.status && user.status.action) {
          UsersByStatus[user.status.action].push(user);
        }

        return UsersByStatus;
      },
      {
        [JOIN_STATUS]: [],
        [AFK_STATUS]: [],
        [LEAVE_STATUS]: [],
        [UNKNOWN_STATUS]: []
      }
    );
  }

  get groupedUsersByLocation() {
    return this.props.users.reduce(
      (usersByLocation, user) => {
        if (user.status && user.status.location) {
          if (usersByLocation[user.status.location.id] === undefined) {
            usersByLocation[user.status.location.id] = [];
          }
          usersByLocation[user.status.location.id].push(user);
        } else if (user.status && user.status.wfh) {
          usersByLocation[WFH_LOCATION].push(user);
        } else {
          usersByLocation[NOT_REVEALED_LOCATION].push(user);
        }

        return usersByLocation;
      },
      { [WFH_LOCATION]: [], [NOT_REVEALED_LOCATION]: [] }
    );
  }

  get groupedUsersByTimeZone() {
    return this.props.users.reduce((usersByTimeZone, user) => {
      if (user.status && user.status.time_zone) {
        if (usersByTimeZone[user.status.time_zone] === undefined) {
          usersByTimeZone[user.status.time_zone] = [];
        }
        usersByTimeZone[user.status.time_zone].push(user);
      }

      return usersByTimeZone;
    }, {});
  }

  userLocation(user) {
    return user.status && user.status.location
      ? this.findLocation(user.status.location.id).name
      : user.status && user.status.wfh && WFH_LOCATION;
  }

  findLocation(locationId) {
    return new TeamLocation(this.props.locations, locationId);
  }

  render() {
    const {
      groupedUsersByLocation,
      groupedUsersByTimeZone,
      groupedUsersByStatus
    } = this;
    const { currentUser, onSnapshot, viewMode } = this.props;

    switch (viewMode) {
      default:
        return (
          <UserBadgeGrid>
            {Object.keys(groupedUsersByLocation).map(
              locationId =>
                groupedUsersByLocation[locationId].length > 0 &&
                groupedUsersByLocation[locationId].map(user => (
                  <Grid.Column key={user.id} {...BADGE_COLUMN_WIDTHS}>
                    <UserBadge
                      user={user}
                      currentUser={currentUser}
                      size="large"
                      location={this.userLocation(user)}
                      onSnapshot={onSnapshot}
                    />
                  </Grid.Column>
                ))
            )}
          </UserBadgeGrid>
        );
      case STATUS_VIEW_MODE:
        return Object.keys(groupedUsersByStatus).map(
          statusId =>
            groupedUsersByStatus[statusId].length > 0 && (
              <div key={`status-${statusId}`}>
                <Divider
                  horizontal
                  content={`${statusId} (${
                    groupedUsersByStatus[statusId].length
                  })`}
                />
                <UserBadgeGrid>
                  {groupedUsersByStatus[statusId].map(user => (
                    <Grid.Column key={user.id} {...BADGE_COLUMN_WIDTHS}>
                      <UserBadge
                        user={user}
                        currentUser={currentUser}
                        size="large"
                        onSnapshot={onSnapshot}
                      />
                    </Grid.Column>
                  ))}
                </UserBadgeGrid>
              </div>
            )
        );
      case LOCATION_VIEW_MODE:
        return Object.keys(groupedUsersByLocation).map(
          locationId =>
            groupedUsersByLocation[locationId].length > 0 && (
              <div key={`location-${locationId}`}>
                <Divider
                  horizontal
                  content={`${this.findLocation(locationId).name} (${
                    groupedUsersByLocation[locationId].length
                  })`}
                />
                <UserBadgeGrid>
                  {groupedUsersByLocation[locationId].map(user => (
                    <Grid.Column key={user.id} {...BADGE_COLUMN_WIDTHS}>
                      <UserBadge
                        user={user}
                        currentUser={currentUser}
                        size="large"
                        onSnapshot={onSnapshot}
                      />
                    </Grid.Column>
                  ))}
                </UserBadgeGrid>
              </div>
            )
        );
      case TIMEZONE_VIEW_MODE:
        return Object.keys(groupedUsersByTimeZone).map(
          timeZoneId =>
            groupedUsersByTimeZone[timeZoneId].length > 0 && (
              <div key={`location-${timeZoneId}`}>
                <Divider
                  horizontal
                  content={`${timeZoneId} (${
                    groupedUsersByTimeZone[timeZoneId].length
                  })`}
                />
                <UserBadgeGrid>
                  {groupedUsersByTimeZone[timeZoneId].map(user => (
                    <Grid.Column key={user.id} {...BADGE_COLUMN_WIDTHS}>
                      <UserBadge
                        user={user}
                        currentUser={currentUser}
                        size="large"
                        location={this.userLocation(user)}
                        onSnapshot={onSnapshot}
                      />
                    </Grid.Column>
                  ))}
                </UserBadgeGrid>
              </div>
            )
        );
    }
  }
}

export default TeamUsersGrid;



// WEBPACK FOOTER //
// ./src/components/TeamUsersGrid.js